module.exports = __webpack_public_path__ + "static/media/img2.c40a0079.jpg";